<template>
  <div class="container pathways__subcomponent">
    <div class="columns is-centered">
      <div class="column is-10-tablet is-8-desktop">
        <p class="title is-3 pathways-question__indicator">Question 1</p>
        <h2 class="title is-1">Are you concerned about yourself or someone else?</h2>
        <div class="columns">
          <div class="column is-half-tablet">
            <PathwaysOption label-text="Myself">
              <input
                type="radio"
                name="self"
                value="self"
                v-model="pathType"
                @change="setNextDisabled(false)"
              >
            </PathwaysOption>
          </div>
          <div class="column is-half-tablet">
            <PathwaysOption label-text="Someone else">
              <input
                type="radio"
                name="other"
                value="other"
                v-model="pathType"
                @change="setNextDisabled(false)"
              >
            </PathwaysOption>
          </div>
        </div>
        <div class="pathways__helpbox rich-text mt-24-32">
          <h3>We do not capture any of your personal data.</h3>
          <p>
            Private, anonymous and secure.<br>
            We don't capture any personal information and our service is entirely confidential.
          </p>
        </div>
        <div class="column mt-32">
          <h2 class="title is-4 pathways-branch__disclaimer">Disclaimer</h2>
          <p class="is-small mb-8">
            The Path2Help portal aims to provide the most up-to-date and credible resources to
            assist people looking for ways to support someone who uses
            alcohol and/or other drugs.
          </p>
          <p class="is-small mb-8">
            Information and support service referrals are determined through the ASSIST (Alcohol,
            Smoking and Substance Involvement Screening Test) model which can help to identify the
            risks associated with alcohol and/or other drug use and explore a person’s
            motivation to change.
          </p>
          <p class="is-small mb-8">
            The content and information provided by Path2Help is intended as a guide to steer
            people towards the most appropriate information and services for their specific
            circumstances as identified by the portal.
          </p>
          <p class="is-small mb-8">
            Path2Help is not intended to be a substitute for professional medical advice,
            diagnosis, or treatment. Please seek individual advice from your doctor or other
            qualified health providers.
          </p>
          <p class="is-small mb-8">
            Path2Help is completely confidential and does not store any of your
            personal information or data.
          </p>
          <p class="is-small">
            Read our full
            <a href="/disclaimer/" class="pathways__terms-link">Terms and Conditions</a>
          </p>
        </div>
        <div class="pathways-branch__footer">
          <span>Powered by</span>
          <info-exchange-logo-icon></info-exchange-logo-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PathwaysOption from '@/components/pathways/PathwaysOption.vue';
import InfoExchangeLogoIcon from '@/components/svg/InfoExchangeLogoIcon.vue';

const { mapActions } = createNamespacedHelpers('pathways');

export default {
  name: 'PathwaysQuestionBranch',
  components: { PathwaysOption, InfoExchangeLogoIcon },
  computed: {
    pathType: {
      get() {
        return this.$store.state.pathways.mode;
      },
      set(value) {
        this.$store.dispatch('pathways/updateMode', value);
      },
    },
  },
  mounted() {
    this.setNextDisabled(!this.pathType);
  },
  methods: {
    ...mapActions({
      setNextDisabled: 'disableNext',
    }),
  },
};
</script>
